exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choice-items[data-v-22a82bd2]{height:320px;overflow-y:scroll;overflow-x:hidden;margin:20px 0;border:1px solid #ddd;padding:16px}.box-param[data-v-22a82bd2]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:20px;background-color:#fff;overflow-y:auto;max-height:500px}.lp-bg-sub-in-title[data-v-22a82bd2]{line-height:2rem}", ""]);

// exports
